
import React from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Send } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const getOrderColumns = () => [
  {
    key: "order_number",
    label: "Order #",
  },
  {
    key: "tailor",
    label: "Tailor",
    render: (row: any) => {
      if (!row.tailor || !row.tailor.profile) {
        return 'N/A';
      }
      
      const firstName = row.tailor.profile.firstName || '';
      const lastName = row.tailor.profile.lastName || '';
      
      // Combine first and last name, or show N/A if both are missing
      if (firstName || lastName) {
        return `${firstName} ${lastName}`.trim();
      }
      
      return 'N/A';
    }
  },
  {
    key: "category",
    label: "Product",
    render: (row: any) => row.category?.name || 'N/A'
  },
  {
    key: "status",
    label: "Status",
    render: (row: any) => {
      const statusStyles = {
        pending: "bg-yellow-100 text-yellow-800 border-yellow-200",
        in_progress: "bg-blue-100 text-blue-800 border-blue-200",
        completed: "bg-green-100 text-green-800 border-green-200",
        canceled: "bg-red-100 text-red-800 border-red-200"
      };
      
      const style = statusStyles[row.status as keyof typeof statusStyles] || "";
      
      return <Badge className={style}>{row.status.replace('_', ' ')}</Badge>;
    }
  },
  {
    key: "total_amount",
    label: "Amount",
    render: (row: any) => `$${parseFloat(row.total_amount).toFixed(2)}`
  },
  // {
  //   key: "actions",
  //   label: "Actions",
  //   render: (row: any) => {
  //     const handleSendEmail = async (e: React.MouseEvent) => {
  //       e.stopPropagation();

  //       try {
  //         // Simulate sending email (you can replace this with actual email sending logic)
  //         console.log(`Sending email for order ${row.order_number}`);
          
  //         // Update order status to 'in_progress' which will trigger the notification automatically
  //         const { error } = await supabase
  //           .from("orders")
  //           .update({ 
  //             status: 'in_progress',
  //             updated_at: new Date().toISOString()
  //           })
  //           .eq("id", row.id);

  //         if (error) {
  //           console.error("Error updating order status:", error);
  //           toast.error("Failed to update order status");
  //           return;
  //         }

  //         const tailorName = row.tailor?.profile?.firstName || 'Tailor';
  //         toast.success(`Order PDF emailed to ${tailorName} and status updated to In Progress`);
  //       } catch (error) {
  //         console.error("Error sending email:", error);
  //         toast.error("Failed to send email");
  //       }
  //     };

  //     // Only show Send button for pending orders
  //     if (row.status === 'pending') {
  //       return (
  //         <Button
  //           variant="outline"
  //           size="sm"
  //           onClick={handleSendEmail}
  //           className="flex items-center gap-2"
  //         >
  //           <Send className="h-4 w-4" />
  //           Send
  //         </Button>
  //       );
  //     }

  //     return null;
  //   }
  // }
];
